import confetti, { Options as ConfettiOptions } from 'canvas-confetti'
import { useRef } from 'react'

export const defaultConfettiOptions: ConfettiOptions = {
  colors: ['#006496', '#66b1d7', '#007dbc', '#f7fbfd'],
}
export function useConfettiGun() {
  const originRef = useRef<HTMLDivElement>(null)
  const origin = <div ref={originRef} css={{ width: 1, height: 1, marginTop: -1 }} />

  const gun = {
    origin,
    shoot: (options: ConfettiOptions = {}) => {
      const originRect = originRef.current?.getBoundingClientRect()
      const origin = originRect
        ? { x: originRect.x / window.innerWidth, y: originRect.y / window.innerHeight }
        : undefined
      confetti({ ...defaultConfettiOptions, origin, ...options })
    },
  }

  return gun
}
